import * as React from 'react';
import { makeTestId } from '../../utils/Declarative';
// eslint-disable-next-line import/no-cycle
import { SliderBaseProps, SliderBaseWidget, SliderHandleAriaAttributes } from './SliderBaseWidget';

/**
 * Enumeration of the possible open ended indicators to apply to a SliderWidget. Use this to
 * apply a darkened track bar for the specified open ended at type.
 */
export enum OpenEndedAt {
  /** Use to darken the track bar from [min, value] inclusive */
  Min,
  /** Use to darken the track bar from [value, max] inclusive */
  Max,
}

export interface SliderProps extends Omit<
  SliderBaseProps,
  'onChange' | 'value' | 'trackBarDataRange' | 'ariaAttributes'
  > {

  /**
   * A collection of aria attributes to be used by assistive technology.
   * **NOTE**: either `ariaLabel` or `ariaAttributes` must be provided.
   */
  ariaAttributes?: SliderHandleAriaAttributes;

  /**
   * When the slider is updated, this is called with the new value.
   * NOTE: The consumer will need to update the 'value' prop passed to the slider for it to be visually updated.
   */
  onChange?: (value: number) => void;

  /** The current value of the slider. It should be within the range of [min, max]. */
  value: number;
}

/**
 * This slider has one handle and lets a user select a value. It allows the user to choose any number
 * from min to max, including decimal numbers.
 */
export function SliderWidget(props: SliderProps): JSX.Element {
  const { ariaAttributes, ...sliderProps } = props;

  // eslint-disable-next-line max-len
  return <SliderBaseWidget {...sliderProps} ariaAttributes={{ leftHandle: ariaAttributes!, rightHandle: undefined }} testId={makeTestId(props.testId, 'Slider')} />;
}
